// extracted by mini-css-extract-plugin
export var fadeInOut = "_1q-3";
export var icon = "_1q-4";
export var savedIndicator = "_1q-2";
export var savingIndicator = "_1q-0";
export var spin = "_1q-1";